<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <h4>Información del Centro de Atención Médica</h4>
          </div>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de la empresa"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Centro de Atención Médica">
  <AyudaEmpresaForm />
</Modal>
    <hr>

    <!-- Datos de la Empresa -->
    <div class="modal-dialog modal-xl" style="z-index: 1;">
      <div class="modal-content">
        <form>
          <div class="modal-body form-card">
<!-- Fila 1: Nombre Corto, Documento, Localidad -->
<div class="row g-2 mb-3">
  <div class="col-12 col-md-4">
    <label class="form-label">Nombre Corto</label>
    <input type="text" class="form-control form-control-sm"
      v-model="datoEmpresa.nombreCorto" style="text-transform:uppercase" disabled>
  </div>
  <div class="col-12 col-md-4">
    <label class="form-label">Documento</label>
    <input type="text" class="form-control form-control-sm"
      v-model="datoEmpresa.documento" style="text-transform:uppercase" disabled>
  </div>
  <div class="col-12 col-md-4">
    <label class="form-label">Localidad</label>
    <input type="text" class="form-control form-control-sm"
      v-model="datoEmpresa.localidadNombre" disabled>
  </div>
</div>

<!-- Fila 2: Razón Social, Nombre -->
<div class="row g-2 mb-3">
  <div class="col-12 col-md-6">
    <label class="form-label">Razón Social</label>
    <input type="text" class="form-control form-control-sm"
      v-model="datoEmpresa.razonSocial" style="text-transform:uppercase" disabled>
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">Nombre comercial</label>
    <input type="text" class="form-control form-control-sm"
      v-model="datoEmpresa.nombre" style="text-transform:uppercase" disabled>
  </div>
</div>

<!-- Fila 3: Dirección -->
<div class="row g-2 mb-3">
  <div class="col-12">
    <label class="form-label">Dirección</label>
    <textarea class="form-control form-control-sm"
      v-model="datoEmpresa.direccion" style="text-transform:uppercase" disabled></textarea>
  </div>
</div>

            <button @click.prevent="mostrarOcultarBloque">
              {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
            </button>

<div v-if="mostrarBloque" class="mb-3 mt-2">
  <div class="row g-2">
    <div class="col-12 col-md-4">
      <label class="form-label">Id. Empresa</label>
      <input type="text" class="form-control form-control-sm"
        v-model="datoEmpresa.idEmpresa" disabled>
    </div>
    <div class="col-6 col-md-2">
      <label class="form-label">Usuario reg.</label>
      <input type="text" class="form-control form-control-sm"
        v-model="datoEmpresa.idUsuarioReg" disabled>
    </div>
    <div class="col-6 col-md-2">
      <label class="form-label">Fecha reg.</label>
      <input type="text" class="form-control form-control-sm"
        :value="getFormattedDate(datoEmpresa.fechaReg)" disabled>
    </div>
    <div class="col-6 col-md-2">
      <label class="form-label">Usuario act.</label>
      <input type="text" class="form-control form-control-sm"
        v-model="datoEmpresa.idUsuarioAct" disabled>
    </div>
    <div class="col-6 col-md-2">
      <label class="form-label">Fecha act.</label>
      <input type="text" class="form-control form-control-sm"
        :value="getFormattedDate(datoEmpresa.fechaAct)" disabled>
    </div>
  </div>
</div>
          </div>
        </form>
      </div>
    </div>

<!-- Tabs -->
<div class="tab-bar mt-3">
  <button
    v-if="suscriptor == 1"
    class="tablink"
    :class="{ 'active-tab': showTable === 'usuarios' }"
    @click="showTable = 'usuarios'"
  >
    <span class="material-symbols-outlined">manage_accounts</span>
    Usuarios
  </button>
  <button
    class="tablink"
    :class="{ 'active-tab': showTable === 'medios' }"
    @click="showTable = 'medios'"
  >
    <span class="material-symbols-outlined">phone_in_talk</span>
    Medios de Comunicación
  </button>
<!--  
  <button
    class="tablink"
    :class="{ 'active-tab': showTable === 'logos' }"
    @click="showTable = 'logos'"
  >
    <span class="material-symbols-outlined">image</span>
    Logos
  </button>
  <button
    v-if="suscriptor == 1"
    class="tablink"
    :class="{ 'active-tab': showTable === 'suscripcion' }"
    @click="showTable = 'suscripcion'"
  >
    <span class="material-symbols-outlined">verified</span>
    Suscripción
  </button>
-->
</div>

    <div v-if="showTable === 'suscripcion' && dataLoaded">
      <SuscripcionEmpr :p_idEmpresa="Number(p_idEmpresa)" />
    </div>
    <div v-if="showTable === 'usuarios'">
      <UsuarioEmp :p_idEmpresa="Number(p_idEmpresa)" />
    </div>
    <div v-if="showTable === 'medios'">
      <MedioEmp :p_idEmpresa="Number(p_idEmpresa)" />
    </div>
    <div v-if="showTable === 'logos'">
      <EmpresaImg :p_idEmpresa="Number(p_idEmpresa)" />
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaEmpresaForm from '@/views/ayuda/AyudaEmpresaForm.vue'
import MedioEmp from '../forms/MedioEmp.vue'
import UsuarioEmp from '../forms/UsuarioEmp.vue'
import SuscripcionEmpr from '../forms/SuscripcionEmpr.vue'
import EmpresaImg from '../forms/EmpresaImg.vue'
import dateFormat from '@/modules/dateFormat.js'
import api from '@/services/api'   // ← reemplaza axios directo

export default {
  props: {
    p_idEmpresa: { type: Number, required: true },
  },

  components: {
    Layout, Footer, AyudaEmpresaForm,
    MedioEmp, UsuarioEmp, SuscripcionEmpr, EmpresaImg,
  },
  data() {
    return {
      datoEmpresa:   {},
      suscriptor:    0,
      showTable:     'usuarios',
      mostrarBloque: false,
      dataLoaded:    false,
      showModalHelp: false,
    }
  },
  mounted() {
    this.suscriptor  = window.sessionStorage.getItem("suscriptor")
    if (this.suscriptor != 1) this.showTable = 'medios'
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.getData()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque
    },
    getData() {
      api.get('/vwempresas/' + this.p_idEmpresa)
        .then(response => {
          this.datoEmpresa = response.data
          this.dataLoaded  = true
        })
        .catch(error => {
          console.error('Error al obtener datos de la empresa:', error)
        })
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>

<style scoped>
.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.tablink:hover { background: #e9ecef; color: #343a40; }
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}
</style>